import { writable } from 'svelte/store';
import type { FilterAttrs } from './filter.type';

const filterSchema: FilterAttrs = {
	topics: 'all',
	media: 'all',
	placename: 'all',
	blooms: 'all',
	query: '',
	owner: 'all',
	drafts: false,
	claims: false,
	rerender: false
};

export const filterStore = writable<FilterAttrs>(filterSchema);
